<template>
  <div class="tracking-ut-view pa-4">
    <!-- 1. Header / Tarjeta de Título Neutra -->
    <v-card class="mb-4 rounded-xl border-light" outlined elevation="0">
      <v-card-title class="d-flex align-center py-4 px-5 flex-wrap">
        <v-avatar color="grey lighten-4" size="42" class="mr-3">
          <v-icon color="grey darken-3">mdi-truck-fast-outline</v-icon>
        </v-avatar>
        <div>
          <h2 class="text-h6 font-weight-black grey--text text--darken-4 mb-0">
            Registro de Ingreso / Salida de UTs
          </h2>
          <span class="text-caption grey--text text--darken-2">
            Seguimiento en tiempo real del flujo de UTs en planta para programaciones de cosecha y acopio.
          </span>
        </div>
      </v-card-title>
    </v-card>

    <!-- 2. Strip de Resumen KPI Neutro -->
    <v-row dense class="mb-4">
      <v-col cols="12" sm="6" md="" class="flex-grow-1">
        <v-card class="rounded-xl pa-3 bg-white border-light h-100" outlined elevation="0">
          <div class="d-flex align-center">
            <v-avatar color="grey lighten-4" size="40" class="mr-3">
              <v-icon color="grey darken-3">mdi-clipboard-text-outline</v-icon>
            </v-avatar>
            <div>
              <div class="text-caption text-uppercase font-weight-bold grey--text text--darken-2">
                Total UTs Programadas
              </div>
              <div class="text-h6 font-weight-black grey--text text--darken-4">
                {{ kpiData.total }} UT(s)
              </div>
            </div>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="" class="flex-grow-1">
        <v-card class="rounded-xl pa-3 bg-white border-light h-100" outlined elevation="0">
          <div class="d-flex align-center">
            <v-avatar color="grey lighten-4" size="40" class="mr-3">
              <v-icon color="grey darken-3">mdi-package-variant-closed</v-icon>
            </v-avatar>
            <div>
              <div class="text-caption text-uppercase font-weight-bold grey--text text--darken-2">
                Total Jabas Solicitadas
              </div>
              <div class="text-h6 font-weight-black grey--text text--darken-4">
                {{ kpiData.totalJabas.toLocaleString('es-PE') }}
              </div>
            </div>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="" class="flex-grow-1">
        <v-card class="rounded-xl pa-3 bg-white border-light h-100" outlined elevation="0">
          <div class="d-flex align-center">
            <v-avatar color="grey lighten-4" size="40" class="mr-3">
              <v-icon color="primary">mdi-flag-outline</v-icon>
            </v-avatar>
            <div>
              <div class="text-caption text-uppercase font-weight-bold grey--text text--darken-2">
                Presentados en Planta
              </div>
              <div class="text-h6 font-weight-black grey--text text--darken-4">
                {{ kpiData.arrival }} UT(s)
              </div>
            </div>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="" class="flex-grow-1">
        <v-card class="rounded-xl pa-3 bg-white border-light h-100" outlined elevation="0">
          <div class="d-flex align-center">
            <v-avatar color="grey lighten-4" size="40" class="mr-3">
              <v-icon color="primary">mdi-gate</v-icon>
            </v-avatar>
            <div>
              <div class="text-caption text-uppercase font-weight-bold grey--text text--darken-2">
                Ingresados a Planta
              </div>
              <div class="text-h6 font-weight-black grey--text text--darken-4">
                {{ kpiData.entry }} UT(s)
              </div>
            </div>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="" class="flex-grow-1">
        <v-card class="rounded-xl pa-3 bg-white border-light h-100" outlined elevation="0">
          <div class="d-flex align-center">
            <v-avatar color="grey lighten-4" size="40" class="mr-3">
              <v-icon color="grey darken-3">mdi-truck-check-outline</v-icon>
            </v-avatar>
            <div>
              <div class="text-caption text-uppercase font-weight-bold grey--text text--darken-2">
                Salidos de Planta
              </div>
              <div class="text-h6 font-weight-black grey--text text--darken-4">
                {{ kpiData.exit }} UT(s)
              </div>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <!-- 3. Tarjeta Filtros de Búsqueda -->
    <v-card class="mb-5 rounded-xl border-light" outlined elevation="0">
      <v-card-title class="py-3 px-5 d-flex align-center flex-wrap">
        <v-icon color="grey darken-3" small class="mr-2">mdi-filter-variant</v-icon>
        <span class="text-subtitle-2 font-weight-bold grey--text text--darken-4 text-uppercase">
          Filtros de Búsqueda
        </span>
      </v-card-title>
      <v-divider></v-divider>

      <v-card-text class="py-4 px-5">
        <v-row dense align="center">
          <v-col cols="12" sm="3" md="2">
            <s-date label="Fecha Inicio" v-model="filter.DateInitial" clearable />
          </v-col>
          <v-col cols="12" sm="3" md="2">
            <s-date label="Fecha Fin" v-model="filter.DateFin" clearable />
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <s-text label="Buscar por Placa, Chofer, Transportista o Productor" v-model="filter.Search" clearable />
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-btn block color="primary" class="rounded-lg font-weight-bold white--text text-none py-4" elevation="0" @click="loadData">
              <v-icon left small>mdi-magnify</v-icon>
              Consultar
            </v-btn>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-btn block color="success" class="rounded-lg font-weight-bold white--text text-none py-4" elevation="0" :loading="downloadingExcel" @click="downloadExcel">
              <v-icon left small>mdi-file-excel-outline</v-icon>
              Exportar Excel
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- 4. Contenedor de TABS Acopio / Cosecha -->
    <v-card class="rounded-xl border-light bg-white pa-4 mb-5" outlined elevation="0">
      <v-tabs v-model="activeTab" color="primary" class="mb-4 border-subtle-bottom" @change="onTabChange">
        <v-tab class="text-none font-weight-bold px-4">
          <v-icon left small>mdi-store-outline</v-icon>
          Programación de Acopio
        </v-tab>
        <v-tab class="text-none font-weight-bold px-4">
          <v-icon left small>mdi-barley</v-icon>
          Programación de Cosecha
        </v-tab>
      </v-tabs>

      <!-- Tabla de Datos -->
      <v-data-table
        :headers="tableHeaders"
        :items="trackingList"
        :loading="loading"
        item-key="groupKey"
        dense
        class="border-rounded elevation-0"
        :items-per-page="15"
      >
        <!-- Formato Fecha -->
        <template v-slot:[`item.HvsDate`]="{ item }">
          <span>{{ item.HvsDate | formatDate }}</span>
        </template>

        <!-- Productor -->
        <template v-slot:[`item.PrdCardName`]="{ item }">
          <div class="d-flex align-center flex-wrap">
            <span class="font-weight-medium grey--text text--darken-4">
              {{ item.PrdCardName || '-' }}
            </span>
            <v-chip
              v-if="item.rawItems && item.rawItems.length > 1"
              x-small
              color="grey lighten-3"
              class="ml-2 font-weight-bold grey--text text--darken-3"
            >
              <v-icon left x-small>mdi-layers-outline</v-icon>
              {{ item.rawItems.length }} progs.
            </v-chip>
          </div>
        </template>

        <!-- N° Jabas Solicitadas (Suma) -->
        <template v-slot:[`item.HvsQuantity`]="{ item }">
          <span class="font-weight-bold grey--text text--darken-4">
            {{ (item.HvsQuantity || 0).toLocaleString('es-PE') }}
          </span>
        </template>

        <!-- Edición Hora Aprox. de Llegada -->
        <template v-slot:[`item.TutApproximateArrivalHour`]="{ item }">
          <s-text
            type="time"
            v-if="isAdmin"
            dense
            hide-details
            placeholder="HH:mm"
            v-model="item.TutApproximateArrivalHour"
            @blur="saveGuideData(item)"
          />
          <span v-else class="font-weight-medium grey--text text--darken-3">
            {{ item.TutApproximateArrivalHour || '-' }}
          </span>
        </template>

        <!-- Destino -->
        <template v-slot:[`item.TypeDestinationName`]="{ item }">
          <span class="font-weight-bold grey--text text--darken-3" v-if="item.TypeDestinationName">
            {{ item.TypeDestinationName }}
          </span>
          <span class="caption grey--text font-italic" v-else>-</span>
        </template>

        <!-- Placa en Chip Primario -->
        <template v-slot:[`item.TutTptEnrollment`]="{ item }">
          <v-chip x-small color="primary" dark class="font-weight-bold" v-if="item.TutTptEnrollment">
            <v-icon left x-small>mdi-truck</v-icon>
            {{ item.TutTptEnrollment }}
          </v-chip>
          <span v-else class="caption grey--text font-italic">Sin placa</span>
        </template>

        <!-- Transportista -->
        <template v-slot:[`item.SpcCompanyName`]="{ item }">
          <span class="font-weight-medium grey--text text--darken-3" v-if="item.SpcCompanyName">
            {{ item.SpcCompanyName }}
          </span>
          <span class="caption grey--text font-italic" v-else>-</span>
        </template>

        <!-- Chofer -->
        <template v-slot:[`item.TptDriverName`]="{ item }">
          <span class="font-weight-medium grey--text text--darken-3" v-if="item.TptDriverName">
            {{ item.TptDriverName }}
          </span>
          <span class="caption grey--text font-italic" v-else>-</span>
        </template>

        <!-- Tipo Materia Prima -->
        <template v-slot:[`item.TypeCultiveName`]="{ item }">
          <span class="font-weight-medium grey--text text--darken-3" v-if="item.TypeCultiveName">
            {{ item.TypeCultiveName }}
          </span>
          <span class="caption grey--text font-italic" v-else>-</span>
        </template>

        <!-- N° Guía Sunshine (Lectura / Consolidado) -->
        <template v-slot:[`item.TutGuideNumber`]="{ item }">
          <div v-if="item.rawItems && item.rawItems.length > 1" class="d-flex flex-column py-1">
            <span
              v-for="(sub, i) in item.rawItems"
              :key="'sub-guide-' + i"
              class="caption font-weight-bold grey--text text--darken-3"
            >
              <v-icon x-small color="grey darken-2" class="mr-1">mdi-file-document-outline</v-icon>
              {{ sub.TutGuideNumber || 'Sin guía' }}
            </span>
          </div>
          <span class="font-weight-bold grey--text text--darken-3" v-else-if="item.TutGuideNumber">
            {{ item.TutGuideNumber }}
          </span>
          <span class="caption grey--text font-italic" v-else>Sin guía</span>
        </template>

        <!-- N° Jabas Guía Remisión (Suma) -->
        <template v-slot:[`item.TutQuantityJabasGuide`]="{ item }">
          <span class="font-weight-bold grey--text text--darken-4" v-if="item.TutQuantityJabasGuide">
            {{ (item.TutQuantityJabasGuide || 0).toLocaleString('es-PE') }}
          </span>
          <span class="caption grey--text font-italic" v-else>-</span>
        </template>

        <!-- Paso 1: Presentación en Planta -->
        <template v-slot:[`item.step1`]="{ item }">
          <div class="d-flex flex-column align-center justify-center py-1">
            <template v-if="isAdmin">
              <v-chip
                v-if="item.TutIsPlantArrival == 1"
                color="success"
                dark
                small
                title="Clic para desmarcar presentación"
                class="font-weight-bold step-chip elevation-1"
                @click="onStepToggle(item, 1, false)"
              >
                <v-icon left x-small>mdi-check-circle</v-icon>
                Presentado
              </v-chip>

              <v-btn
                v-else
                outlined
                color="primary"
                x-small
                title="Clic para marcar presentación"
                class="rounded-pill font-weight-bold text-none step-btn"
                @click="onStepToggle(item, 1, true)"
              >
                <v-icon left x-small>mdi-checkbox-blank-circle-outline</v-icon>
                Marcar
              </v-btn>
            </template>
            <template v-else>
              <v-chip
                v-if="item.TutIsPlantArrival == 1"
                color="success"
                dark
                small
                class="font-weight-bold"
              >
                <v-icon left x-small>mdi-check-circle</v-icon>
                Presentado
              </v-chip>
              <v-chip
                v-else
                x-small
                class="font-weight-medium grey lighten-4 grey--text text--darken-1 border-light"
              >
                <v-icon left x-small>mdi-clock-outline</v-icon>
                Pendiente
              </v-chip>
            </template>

            <span class="step-timestamp grey--text text--darken-2 font-weight-medium mt-1 d-flex align-center" v-if="item.TutIsPlantArrival == 1 && item.TutDatePlantArrival">
              <v-icon x-small color="grey darken-1" class="mr-1">mdi-clock-outline</v-icon>
              {{ item.TutDatePlantArrival | formatDateTime }}
            </span>
          </div>
        </template>

        <!-- Paso 2: Ingreso a Planta -->
        <template v-slot:[`item.step2`]="{ item }">
          <div class="d-flex flex-column align-center justify-center py-1">
            <template v-if="isAdmin">
              <v-chip
                v-if="item.TutIsPlantEntry == 1"
                color="success"
                dark
                small
                title="Clic para desmarcar ingreso"
                class="font-weight-bold step-chip elevation-1"
                @click="onStepToggle(item, 2, false)"
              >
                <v-icon left x-small>mdi-check-circle</v-icon>
                Ingresado
              </v-chip>

              <v-btn
                v-else-if="item.TutIsPlantArrival == 1"
                outlined
                color="primary"
                x-small
                title="Clic para marcar ingreso"
                class="rounded-pill font-weight-bold text-none step-btn"
                @click="onStepToggle(item, 2, true)"
              >
                <v-icon left x-small>mdi-checkbox-blank-circle-outline</v-icon>
                Marcar
              </v-btn>

              <v-chip
                v-else
                disabled
                x-small
                title="Requiere confirmar presentación primero"
                class="font-weight-medium grey lighten-4 grey--text text--darken-1 border-light"
              >
                <v-icon left x-small>mdi-lock-outline</v-icon>
                Bloqueado
              </v-chip>
            </template>
            <template v-else>
              <v-chip
                v-if="item.TutIsPlantEntry == 1"
                color="success"
                dark
                small
                class="font-weight-bold"
              >
                <v-icon left x-small>mdi-check-circle</v-icon>
                Ingresado
              </v-chip>
              <v-chip
                v-else
                x-small
                class="font-weight-medium grey lighten-4 grey--text text--darken-1 border-light"
              >
                <v-icon left x-small>mdi-clock-outline</v-icon>
                Pendiente
              </v-chip>
            </template>

            <span class="step-timestamp grey--text text--darken-2 font-weight-medium mt-1 d-flex align-center" v-if="item.TutIsPlantEntry == 1 && item.TutDatePlantEntry">
              <v-icon x-small color="grey darken-1" class="mr-1">mdi-clock-outline</v-icon>
              {{ item.TutDatePlantEntry | formatDateTime }}
            </span>
          </div>
        </template>

        <!-- Paso 3: Salida de Planta -->
        <template v-slot:[`item.step3`]="{ item }">
          <div class="d-flex flex-column align-center justify-center py-1">
            <template v-if="isAdmin">
              <v-chip
                v-if="item.TutIsPlantExit == 1"
                color="success"
                dark
                small
                title="Clic para desmarcar salida"
                class="font-weight-bold step-chip elevation-1"
                @click="onStepToggle(item, 3, false)"
              >
                <v-icon left x-small>mdi-check-circle</v-icon>
                Salido
              </v-chip>

              <v-btn
                v-else-if="item.TutIsPlantEntry == 1"
                outlined
                color="primary"
                x-small
                title="Clic para marcar salida"
                class="rounded-pill font-weight-bold text-none step-btn"
                @click="onStepToggle(item, 3, true)"
              >
                <v-icon left x-small>mdi-checkbox-blank-circle-outline</v-icon>
                Marcar
              </v-btn>

              <v-chip
                v-else
                disabled
                x-small
                title="Requiere confirmar ingreso primero"
                class="font-weight-medium grey lighten-4 grey--text text--darken-1 border-light"
              >
                <v-icon left x-small>mdi-lock-outline</v-icon>
                Bloqueado
              </v-chip>
            </template>
            <template v-else>
              <v-chip
                v-if="item.TutIsPlantExit == 1"
                color="success"
                dark
                small
                class="font-weight-bold"
              >
                <v-icon left x-small>mdi-check-circle</v-icon>
                Salido
              </v-chip>
              <v-chip
                v-else
                x-small
                class="font-weight-medium grey lighten-4 grey--text text--darken-1 border-light"
              >
                <v-icon left x-small>mdi-clock-outline</v-icon>
                Pendiente
              </v-chip>
            </template>

            <span class="step-timestamp grey--text text--darken-2 font-weight-medium mt-1 d-flex align-center" v-if="item.TutIsPlantExit == 1 && item.TutDatePlantExit">
              <v-icon x-small color="grey darken-1" class="mr-1">mdi-clock-outline</v-icon>
              {{ item.TutDatePlantExit | formatDateTime }}
            </span>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <!-- Modal de Confirmación Detallada de Guías y UTs -->
    <v-dialog v-model="confirmDialog.show" max-width="600" persistent>
      <v-card class="rounded-xl border-light pa-2" elevation="0">
        <v-card-title class="d-flex align-center pb-2">
          <v-avatar color="grey lighten-4" size="40" class="mr-3">
            <v-icon color="primary">mdi-truck-check-outline</v-icon>
          </v-avatar>
          <div>
            <div class="text-subtitle-1 font-weight-black grey--text text--darken-4">
              {{ confirmDialog.title }}
            </div>
            <div class="text-caption grey--text text--darken-2">
              Verifique el detalle de las guías y cargas a procesar para esta Unidad de Transporte.
            </div>
          </div>
        </v-card-title>

        <v-divider class="my-2"></v-divider>

        <v-card-text class="py-2">
          <!-- Info Cabecera UT -->
          <div class="d-flex align-center justify-space-between mb-3 grey lighten-5 pa-3 rounded-lg border-light flex-wrap">
            <div class="d-flex align-center mr-2 my-1">
              <v-chip color="primary" small dark class="font-weight-bold mr-2">
                <v-icon left x-small>mdi-truck</v-icon>
                {{ confirmDialog.item ? (confirmDialog.item.TutTptEnrollment || 'Sin Placa') : '' }}
              </v-chip>
              <span class="text-caption font-weight-medium grey--text text--darken-3">
                {{ confirmDialog.item ? (confirmDialog.item.TptDriverName || confirmDialog.item.SpcCompanyName || '-') : '-' }}
              </span>
            </div>
            <v-chip color="grey darken-3" small dark class="font-weight-bold my-1">
              Total: {{ confirmDialog.item ? (confirmDialog.item.TutQuantityJabasGuide || confirmDialog.item.HvsQuantity || 0).toLocaleString('es-PE') : 0 }} Jabas
            </v-chip>
          </div>

          <!-- Lista de Guías / Programaciones Involucradas -->
          <div class="text-caption font-weight-bold grey--text text--darken-3 mb-2 text-uppercase">
            Programaciones / Guías Involucradas ({{ confirmDialog.item && confirmDialog.item.rawItems ? confirmDialog.item.rawItems.length : 1 }}):
          </div>

          <v-card outlined class="rounded-lg border-light pa-0 mb-2 overflow-hidden" max-height="240" style="overflow-y: auto;">
            <v-list dense class="pa-0">
              <div
                v-for="(sub, idx) in (confirmDialog.item && confirmDialog.item.rawItems ? confirmDialog.item.rawItems : [])"
                :key="'dialog-sub-' + idx"
              >
                <v-list-item class="py-2">
                  <v-list-item-avatar size="28" color="grey lighten-3" class="my-0 mr-3">
                    <span class="caption font-weight-bold grey--text text--darken-4">{{ idx + 1 }}</span>
                  </v-list-item-avatar>
                  <v-list-item-content class="py-0">
                    <v-list-item-title class="font-weight-bold text-caption grey--text text--darken-4 d-flex align-center">
                      <v-icon x-small color="grey darken-2" class="mr-1">mdi-file-document-outline</v-icon>
                      Guía: {{ sub.TutGuideNumber || 'Sin guía generada' }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="text-caption grey--text text--darken-2 mt-1">
                      Productor: <b>{{ sub.PrdCardName || '-' }}</b>
                      <span v-if="sub.FagName"> | Zona: {{ sub.FagName }}</span>
                      <span v-if="sub.TypeCultiveName"> | {{ sub.TypeCultiveName }}</span>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action class="my-0">
                    <v-chip x-small color="grey lighten-2" class="font-weight-bold grey--text text--darken-4">
                      {{ (sub.TutQuantityJabasGuide || sub.HvsQuantity || 0).toLocaleString('es-PE') }} jabas
                    </v-chip>
                  </v-list-item-action>
                </v-list-item>
                <v-divider v-if="idx < (confirmDialog.item.rawItems.length - 1)"></v-divider>
              </div>
            </v-list>
          </v-card>
        </v-card-text>

        <v-card-actions class="px-4 pb-3 pt-1">
          <v-spacer></v-spacer>
          <v-btn text color="grey darken-1" class="rounded-lg text-none font-weight-bold px-4" @click="confirmDialog.show = false" :disabled="confirmDialog.loading">
            Cancelar
          </v-btn>
          <v-btn color="primary" class="rounded-lg text-none font-weight-bold px-5" elevation="0" @click="executeStepConfirm" :loading="confirmDialog.loading">
            <v-icon left small>mdi-check</v-icon>
            Confirmar {{ confirmDialog.actionName }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _sTrackingUT from "@/services/Technicalassistance/TrackingUTService";

export default {
  name: "TrackingUT",
  data() {
    return {
      activeTab: 0,
      loading: false,
      downloadingExcel: false,
      filter: {
        TutTypeSchedule: 2,
        DateInitial: new Date().toISOString().substr(0, 10),
        DateFin: new Date().toISOString().substr(0, 10),
        Search: ""
      },
      trackingList: [],
      confirmDialog: {
        show: false,
        loading: false,
        item: null,
        step: 1,
        value: true,
        actionName: "",
        title: ""
      },
      tableHeaders: [
        { text: "Fecha", value: "HvsDate", width: "100px", sortable: false },
        { text: "Productor", value: "PrdCardName", sortable: false },
        { text: "N° Jabas Solicitadas", value: "HvsQuantity", width: "120px", sortable: false, align: "right" },
        { text: "Zona Carga", value: "FagName", width: "120px", sortable: false },
        { text: "Destino", value: "TypeDestinationName", width: "110px", sortable: false },
        { text: "Placa", value: "TutTptEnrollment", width: "100px", sortable: false },
        { text: "Transportista", value: "SpcCompanyName", width: "150px", sortable: false },
        { text: "Chofer", value: "TptDriverName", width: "150px", sortable: false },
        { text: "Tipo Materia Prima", value: "TypeCultiveName", width: "130px", sortable: false },
        { text: "Hora Aprox.", value: "TutApproximateArrivalHour", width: "100px", sortable: false },
        { text: "N° Guía Sunshine", value: "TutGuideNumber", width: "150px", sortable: false },
        { text: "N° Jabas Guía", value: "TutQuantityJabasGuide", width: "110px", sortable: false, align: "right" },
        { text: "1. Presentación Planta", value: "step1", align: "center", width: "140px", sortable: false },
        { text: "2. Ingreso a Planta", value: "step2", align: "center", width: "140px", sortable: false },
        { text: "3. Salida de Planta", value: "step3", align: "center", width: "140px", sortable: false }
      ]
    };
  },
  computed: {
    isAdmin() {
      return !!(this.$fun && typeof this.$fun.isAdmin === 'function' && this.$fun.isAdmin());
    },
    kpiData() {
      const total = this.trackingList.length;
      const totalJabas = this.trackingList.reduce((acc, curr) => acc + (Number(curr.HvsQuantity) || 0), 0);
      const arrival = this.trackingList.filter(x => x.TutIsPlantArrival == 1).length;
      const entry = this.trackingList.filter(x => x.TutIsPlantEntry == 1).length;
      const exit = this.trackingList.filter(x => x.TutIsPlantExit == 1).length;
      return { total, totalJabas, arrival, entry, exit };
    }
  },
  filters: {
    formatDate(val) {
      if (!val) return "";
      const d = new Date(val);
      return d.toLocaleDateString("es-PE");
    },
    formatTime(val) {
      if (!val) return "";
      const d = new Date(val);
      return d.toLocaleTimeString("es-PE", { hour: "2-digit", minute: "2-digit" });
    },
    formatDateTime(val) {
      if (!val) return "";
      const d = new Date(val);
      return d.toLocaleDateString("es-PE") + " " + d.toLocaleTimeString("es-PE", { hour: "2-digit", minute: "2-digit", second: "2-digit" });
    }
  },
  created() {
    this.loadData();
  },
  methods: {
    onTabChange(tabIndex) {
      this.filter.TutTypeSchedule = tabIndex === 0 ? 2 : 1;
      this.loadData();
    },

    groupTrackingData(rawList) {
      const groupsMap = new Map();

      (rawList || []).forEach((item, index) => {
        const plate = (item.TutTptEnrollment || "").trim().toUpperCase();
        const dateStr = item.HvsDate ? new Date(item.HvsDate).toISOString().substr(0, 10) : "no_date";
        
        // Si tiene placa, agrupamos por Fecha + Placa; si no tiene placa, queda como registro individual único
        const groupKey = plate ? `${dateStr}_${plate}` : `no_plate_${index}_${item.TutDocEntry}`;

        if (!groupsMap.has(groupKey)) {
          groupsMap.set(groupKey, {
            groupKey,
            rawItems: [],
            TutID: item.TutID || 0,
            TutDocEntry: item.TutDocEntry,
            HvsDate: item.HvsDate,
            TutTptEnrollment: item.TutTptEnrollment,
            SpcCompanyName: item.SpcCompanyName,
            TptDriverName: item.TptDriverName,
            TypeCultiveName: item.TypeCultiveName,
            TypeDestinationName: item.TypeDestinationName,
            TutApproximateArrivalHour: item.TutApproximateArrivalHour || "",
            TutIsPlantArrival: 0,
            TutDatePlantArrival: null,
            TutIsPlantEntry: 0,
            TutDatePlantEntry: null,
            TutIsPlantExit: 0,
            TutDatePlantExit: null
          });
        }

        const grp = groupsMap.get(groupKey);
        grp.rawItems.push(item);
      });

      const result = [];
      groupsMap.forEach(grp => {
        const raw = grp.rawItems;
        
        // Productores únicos
        const producers = Array.from(new Set(raw.map(x => (x.PrdCardName || "").trim()).filter(Boolean)));
        grp.PrdCardName = producers.join(", ");

        // Total Jabas Solicitadas
        grp.HvsQuantity = raw.reduce((sum, x) => sum + (Number(x.HvsQuantity) || 0), 0);

        // Zonas de Carga únicas
        const zones = Array.from(new Set(raw.map(x => (x.FagName || "").trim()).filter(Boolean)));
        grp.FagName = zones.join(", ");

        // Destinos únicos
        const destinations = Array.from(new Set(raw.map(x => (x.TypeDestinationName || "").trim()).filter(Boolean)));
        grp.TypeDestinationName = destinations.join(", ");

        // Transportistas únicos
        const carriers = Array.from(new Set(raw.map(x => (x.SpcCompanyName || "").trim()).filter(Boolean)));
        grp.SpcCompanyName = carriers.join(", ");

        // Choferes únicos
        const drivers = Array.from(new Set(raw.map(x => (x.TptDriverName || "").trim()).filter(Boolean)));
        grp.TptDriverName = drivers.join(", ");

        // Cultivos únicos
        const cultives = Array.from(new Set(raw.map(x => (x.TypeCultiveName || "").trim()).filter(Boolean)));
        grp.TypeCultiveName = cultives.join(", ");

        // Guías únicas
        const guides = Array.from(new Set(raw.map(x => (x.TutGuideNumber || "").trim()).filter(Boolean)));
        grp.TutGuideNumber = guides.join(", ");

        // Total Jabas de Guía
        grp.TutQuantityJabasGuide = raw.reduce((sum, x) => sum + (Number(x.TutQuantityJabasGuide) || 0), 0);

        // Hora aproximada de llegada
        const hourItem = raw.find(x => (x.TutApproximateArrivalHour || "").trim());
        grp.TutApproximateArrivalHour = hourItem ? hourItem.TutApproximateArrivalHour : (grp.TutApproximateArrivalHour || "");

        // Pasos del flujo
        grp.TutIsPlantArrival = raw.every(x => x.TutIsPlantArrival == 1) ? 1 : 0;
        const arrivalDateItem = raw.find(x => x.TutDatePlantArrival);
        grp.TutDatePlantArrival = arrivalDateItem ? arrivalDateItem.TutDatePlantArrival : null;

        grp.TutIsPlantEntry = raw.every(x => x.TutIsPlantEntry == 1) ? 1 : 0;
        const entryDateItem = raw.find(x => x.TutDatePlantEntry);
        grp.TutDatePlantEntry = entryDateItem ? entryDateItem.TutDatePlantEntry : null;

        grp.TutIsPlantExit = raw.every(x => x.TutIsPlantExit == 1) ? 1 : 0;
        const exitDateItem = raw.find(x => x.TutDatePlantExit);
        grp.TutDatePlantExit = exitDateItem ? exitDateItem.TutDatePlantExit : null;

        result.push(grp);
      });

      return result;
    },

    loadData() {
      this.loading = true;
      _sTrackingUT.list(this.filter, this.$fun.getUserID())
        .then(resp => {
          this.loading = false;
          if (resp && resp.status === 200) {
            this.trackingList = this.groupTrackingData(resp.data || []);
          }
        })
        .catch(() => {
          this.loading = false;
          this.$fun.alert("Error al cargar la información de seguimiento", "error");
        });
    },

    onStepToggle(item, step, value) {
      if (!this.isAdmin) {
        this.$fun.alert("No tiene permisos de administrador para realizar modificaciones.", "warning");
        return;
      }

      let stepName = "";
      if (step === 1) stepName = "Presentación en Planta";
      if (step === 2) stepName = "Ingreso a Planta";
      if (step === 3) stepName = "Salida de Planta";

      const isChecked = !!value;

      // Validación de secuencia para desmarcar
      if (!isChecked) {
        const hasSubEntryOrExit = (item.rawItems || [item]).some(x => x.TutIsPlantEntry == 1 || x.TutIsPlantExit == 1);
        const hasSubExit = (item.rawItems || [item]).some(x => x.TutIsPlantExit == 1);

        if (step === 1 && hasSubEntryOrExit) {
          this.$fun.alert("No se puede desmarcar la Presentación en Planta porque existen pasos posteriores registrados. Debe desmarcar primero el Ingreso y/o Salida de Planta.", "warning");
          return;
        }
        if (step === 2 && hasSubExit) {
          this.$fun.alert("No se puede desmarcar el Ingreso a Planta porque la Salida ya fue registrada. Debe desmarcar primero la Salida de Planta.", "warning");
          return;
        }
      }

      const actionName = isChecked ? stepName : `Desmarcar ${stepName}`;
      const title = isChecked ? `¿Confirmar ${stepName}?` : `¿Desmarcar ${stepName}?`;

      this.confirmDialog = {
        show: true,
        loading: false,
        item: item,
        step: step,
        value: isChecked,
        actionName: actionName,
        title: title
      };
    },

    executeStepConfirm() {
      const { item, step, value } = this.confirmDialog;
      if (!item) return;

      const isChecked = !!value;
      const valByte = isChecked ? 1 : 0;
      this.confirmDialog.loading = true;

      const childItems = item.rawItems && item.rawItems.length ? item.rawItems : [item];
      const savePromises = childItems.map(child => {
        const payload = {
          TutID: child.TutID || 0,
          TutTypeSchedule: this.filter.TutTypeSchedule,
          TutDocEntry: child.TutDocEntry,
          TutTptEnrollment: child.TutTptEnrollment || item.TutTptEnrollment || "",
          TutGuideNumber: child.TutGuideNumber || "",
          TutQuantityJabasGuide: child.TutQuantityJabasGuide || 0,
          TutApproximateArrivalHour: item.TutApproximateArrivalHour || child.TutApproximateArrivalHour || "",
          TutIsPlantArrival: step === 1 ? valByte : (child.TutIsPlantArrival ? 1 : 0),
          TutDatePlantArrival: step === 1 ? null : child.TutDatePlantArrival,
          TutIsPlantEntry: step === 2 ? valByte : (child.TutIsPlantEntry ? 1 : 0),
          TutDatePlantEntry: step === 2 ? null : child.TutDatePlantEntry,
          TutIsPlantExit: step === 3 ? valByte : (child.TutIsPlantExit ? 1 : 0),
          TutDatePlantExit: step === 3 ? null : child.TutDatePlantExit,
          TutStatus: 1,
          SecStatus: 1
        };
        return _sTrackingUT.save(payload, this.$fun.getUserID());
      });

      Promise.all(savePromises)
        .then(() => {
          this.confirmDialog.loading = false;
          this.confirmDialog.show = false;
          this.$fun.alert("Registro(s) actualizado(s) correctamente", "success");
          this.loadData();
        })
        .catch(() => {
          this.confirmDialog.loading = false;
          this.confirmDialog.show = false;
          this.$fun.alert("Error al actualizar los registros", "error");
          this.loadData();
        });
    },

    saveGuideData(item) {
      if (!this.isAdmin) return;
      const childItems = item.rawItems && item.rawItems.length ? item.rawItems : [item];

      const savePromises = childItems.map(child => {
        const payload = {
          TutID: child.TutID || 0,
          TutTypeSchedule: this.filter.TutTypeSchedule,
          TutDocEntry: child.TutDocEntry,
          TutTptEnrollment: child.TutTptEnrollment || item.TutTptEnrollment || "",
          TutGuideNumber: child.TutGuideNumber || "",
          TutQuantityJabasGuide: child.TutQuantityJabasGuide || 0,
          TutApproximateArrivalHour: item.TutApproximateArrivalHour || "",
          TutIsPlantArrival: child.TutIsPlantArrival ? 1 : 0,
          TutDatePlantArrival: child.TutDatePlantArrival,
          TutIsPlantEntry: child.TutIsPlantEntry ? 1 : 0,
          TutDatePlantEntry: child.TutDatePlantEntry,
          TutIsPlantExit: child.TutIsPlantExit ? 1 : 0,
          TutDatePlantExit: child.TutDatePlantExit,
          TutStatus: 1,
          SecStatus: 1
        };
        return _sTrackingUT.save(payload, this.$fun.getUserID());
      });

      Promise.all(savePromises);
    },

    downloadExcel() {
      this.downloadingExcel = true;
      _sTrackingUT.excel(this.filter, this.$fun.getUserID())
        .then(response => {
          this.downloadingExcel = false;
          if (response && response.data) {
            const blob = new Blob([response.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            const typeScheduleName = this.filter.TutTypeSchedule === 1 ? "Cosecha" : "Acopio";
            const dateStr = new Date().toISOString().substr(0, 10);
            link.setAttribute("download", `Seguimiento_UTs_${typeScheduleName}_${dateStr}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          }
        })
        .catch(() => {
          this.downloadingExcel = false;
          this.$fun.alert("Error al descargar el reporte en Excel", "error");
        });
    }
  }
};
</script>

<style scoped>
.border-light {
  border: 1px solid #e2e8f0;
}
.border-subtle-bottom {
  border-bottom: 1px solid #e2e8f0;
}
.step-chip {
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.step-chip:hover {
  transform: translateY(-1px);
  filter: brightness(0.95);
}
.step-btn {
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.step-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
}
.step-timestamp {
  font-size: 0.72rem !important;
  line-height: 1rem;
}
</style>
